<template>
  <div class="qygk">
    <div class="gk">
      <div class="title"><span class="yuan"></span>区域描述</div>
      <p class="description">
        &emsp;&emsp;1.长江三角洲，位于中国华东地区，包括‌上海市、‌江苏省、‌浙江省和‌安徽省，共41个城市，区域面积为35.8万平方千米。<br />
        &emsp;&emsp;2.
        该区域作为中国经济发展最活跃的区域之一，由于化工产业集聚、城镇化快速发展而面临较为严峻的土壤污染问题。<br />
        &emsp;&emsp;3.
        基于文献资料与现场监测获取土壤污染基础数据，构建污染分布与健康风险评估平台，服务于长三角农用地土壤污染风险预警及防治。
      </p>
      <div class="title">
        <span class="yuan"></span>重金属和多环芳烃浓度图表
      </div>
      <div class="ndtb">
        <div class="zjsnd" ref="zjsnd"></div>
        <div class="dhfj" ref="dhfj"></div>
      </div>
    </div>

    <div class="tdly">
      <div class="title"><span class="yuan"></span>土地利用图</div>
      <div class="imgbox">
        <!-- <div class="map" ref="map"></div>
        <div class="label">
          <div>
            <span style="background-color: #eac99c"></span>
            农田
          </div>
          <div>
            <span style="background-color: #4a6f3a"></span>
            森林
          </div>
          <div>
            <span style="background-color: #34a42c"></span>
            灌木
          </div>
          <div>
            <span style="background-color: #6c8644"></span>
            草地
          </div>
          <div>
            <span style="background-color: #2e70b0"></span>
            水体
          </div>
          <div>
            <span style="background-color: #acac6c"></span>
            裸土
          </div>
          <div>
            <span style="background-color: #d24f90"></span>
            城市
          </div>
        </div> -->
      </div>
    </div>
    <div class="right">
      <div class="title"><span class="yuan"></span>土地利用占比</div>
      <div class="tdlyzb" ref="tdlyzb"></div>
      <!-- <div class="title"><span class="yuan"></span>数据量图表</div> -->
      <div class="sjltb">
        <div class="sjltb_item">
          <div class="title"><span class="yuan"></span>重金属数据量图表</div>
          <div class="zjssjl" ref="zjssjl"></div>
        </div>
        <div class="sjltb_item">
          <div class="title"><span class="yuan"></span>多环芳烃数据量图表</div>
          <div class="dhfjsjl" ref="dhfjsjl"></div>
        </div>
        
      </div>
    </div>
  </div>
</template>
<script>
import apiService from "@/request/api";
import anhui from "@/assets/anhui.json";
import zhejiang from "@/assets/zhejiang.json";
import shanghaishi from "@/assets/shanghaishi.json";
import jiangshu from "@/assets/jiangshu.json";
import * as Echarts from "echarts";
export default {
  data() {
    return {
      axisLabelFlag: false,
    };
  },
  methods: {
    initEcharts() {
      var csj = {
        type: "FeatureCollection",
        features: shanghaishi.features.concat(
          zhejiang.features,
          anhui.features,
          jiangshu.features
        ),
      };

      const _this = this;
      const charts = Echarts.init(this.$refs["map"]);
      const option = {
        series: [
          {
            name: "城市",
            type: "map",
            geoIndex: 0,
            data: _this.datalist,
          },
        ],
        // visualMap: {
        //   min: _this.mincolor,
        //   max: _this.maxcolor,
        //   // min:0,
        //   // max:,
        //   calculable: true,
        //   left: "left",
        //   top: "bottom",
        //   text: ["高", "低"], //取值范围的文字
        //   inRange: {
        //     // color:_this.colorfw , //取值范围的颜色
        //     color: ["green", "red"], //取值范围的颜色
        //     // color: ['#0B3B79', '#146fd7']
        //   },
        //   show: true, //图注
        // },
        // tooltip: {
        //   formatter: function (params) {
        //     // console.log(params,"数据")
        //     if (isNaN(params.value)) {
        //       return params.seriesName + "<br />" + params.name + "：暂无数据";
        //     } else {
        //       if (_this.type1 == 1) {
        //         return (
        //           params.seriesName +
        //           "<br />" +
        //           params.name +
        //           "：污染浓度" +
        //           params.value +
        //           "mg/kg"
        //         );
        //       } else {
        //         return (
        //           params.seriesName +
        //           "<br />" +
        //           params.name +
        //           "：污染浓度" +
        //           params.value +
        //           "μg/kg"
        //         );
        //       }
        //     }
        //   },
        // },
        // backgroundColor: '#0e2152',
        geo: {
          //地图配置
          map: "csj",
          zoom: 1.2,
          // roam: true,
          itemStyle: {
            //地图区域样式
            normal: {
              borderColor: "#00000050",
              borderWidth: 1,
              areaColor: "#00000000",
              // {
              //   type: "radial",
              //   x: 0.5,
              //   y: 0.5,
              //   r: 0.8,
              //   colorStops: [
              //     {
              //       offset: 0,
              //       color: "rgba(0, 102, 154, 0)", // 0% 处的颜色
              //     },
              //     {
              //       offset: 1,
              //       color: "rgba(0, 102, 154, .4)", // 100% 处的颜色
              //     },
              //   ],
              // },
            },
            emphasis: {
              //高亮样式
              areaColor: "#2386AD",
            },
          },
          //   regions: [{
          //     name: '上海市', // 省份名，确保是 ECharts 中有的省份名
          //     itemStyle: {
          //         normal: {
          //             areaColor: 'red',
          //             borderColor: 'yellow' // 广东省份的边界颜色
          //         },
          //         emphasis: {
          //             areaColor: 'red'
          //         }
          //     }
          // }],

          label: {
            //文本标签样式
            normal: {
              show: false,
              textStyle: {
                color: "#fff",
              },
            },
            emphasis: {
              //高亮样式
              textStyle: {
                color: "yellow",
              },
            },
          },
          // 鼠标悬浮提示框
        },
      };
      Echarts.registerMap("csj", csj);
      charts.setOption(option);
      // charts.on("click", function (params) {
      //   console.log(params.name);
      //   _this.city = params.name;
      //   console.log(111, _this.city);
      //   // charts.dispatchAction({
      //   //   type: 'downplay',
      //   //   seriesIndex: 0,
      //   //   dataIndex: charts.getOption().series[0].data.findIndex(item => item.name === "上海市")
      //   // });
      //   _this.changeCity();
      // });
      // charts.dispatchAction({
      //   type: 'highlight',
      //   seriesIndex: 0,
      //   dataIndex: charts.getOption().series[0].data.findIndex(item => item.name === "上海市")
      // });
    },
    async initEcharts1() {
      const _this = this;
      const charts1 = Echarts.init(this.$refs["zjsnd"]);
      
      var overviewChartID = "overview-chart";
      var overviewTitle = ""; //标题
      var overviewSubTitle = Echarts.format.formatTime(
        "yyyy年MM月dd",
        new Date()
      );

      //图表定位
      var chartGridTop = 10;
      var chartGridHeight = 60;

      //时间轴
      //SELECT WMSYS.WM_CONCAT('"'||TO_CHAR(TRUNC(SYSDATE, 'MM') + ROWNUM - 1, 'YYYY-MM-DD')||'"') DBTIME FROM DUAL CONNECT BY ROWNUM <= 30;
      var overviewDate = [

      ];

      //表格数据
      //SELECT WMSYS.WM_CONCAT(TRUNC(DBMS_RANDOM.VALUE(5, 60), 2)) DBTIME FROM DUAL CONNECT BY ROWNUM <= 30;

      var Hg = [
       
      ];
      var As = [
       
      ];
      var Cr = [
        
      ];
      var Ni = [
        
      ];
      var Zn = [
        
      ];
      var Cu = [
        
      ];
      var Pb = [
       
      ];
      var Cd = [
     
      ];
      // 接口请求
      const params ={
        all:1
      }
      const res = await apiService.MetalAverageAnnual(params)
      console.log(res.data.results)
      let list = res.data.results
      for(var i=0;i<list.length;i++){
        if(list[i].type=="Cd"){
          overviewDate.push(list[i].year)
          Cd.push(list[i].value)
        }  
        if(list[i].type=="As"){
          As.push(list[i].value)
        }  
        if(list[i].type=="Pb"){
          Pb.push(list[i].value)
        }  
        if(list[i].type=="Zn"){
          Zn.push(list[i].value)
        }  
        if(list[i].type=="Hg"){
          Hg.push(list[i].value)
        }  
        if(list[i].type=="Cu"){
          Cu.push(list[i].value)
        }  
        if(list[i].type=="Ni"){
          Ni.push(list[i].value)
        }  
        if(list[i].type=="Cr"){
          Cr.push(list[i].value)
        }  
      }
      //直角坐标系内绘图网格
      function makeGrid(top, height, opt) {
        return Echarts.util.merge(
          {
            left: 30,
            right: 8,
            top: top,
            height: height,
          },
          opt || {},
          true
        );
      }

      //X轴生成器
      function makeXAxis(gridIndex, opt) {
        //避免X轴数据显示过于频繁
        _this.axisLabelFlag = false;
        //  if (gridIndex % 2 == 0) {
        //      axisLabelFlag = true;
        //  }
        if (gridIndex == 7) {
          _this.axisLabelFlag = true;
        }

        return Echarts.util.merge(
          {
            type: "category",
            gridIndex: gridIndex,
            //统一时间轴数据
            data: overviewDate,
            axisLabel: {
              show: _this.axisLabelFlag,
              /*          formatter: function(value) {
					              return Echarts.format.formatTime('MM-dd', value);
					          }*/
            },
          },
          opt || {},
          true
        );
      }

      //Y轴生成器
      function makeYAxis(gridIndex, opt) {
        return Echarts.util.merge(
          {
            type: "value",
            // nameLocation: "middle",
            nameGap: "-5",
            gridIndex: gridIndex,
            nameTextStyle: {
              color: "#fff",
              padding: [0, 0, 0, 20],
            },
            axisTick: {
              show: true,
            },
            axisLabel: {
              show: true,
            },
          },
          opt || {},
          true
        );
      }

      //数据生成器
      function makeGridData(
        xAxisIndex,
        yAxisIndex,
        chartType,
        chartName,
        chartData,
        opt
      ) {
        return Echarts.util.merge(
          {
            type: chartType,
            name: chartName,
            xAxisIndex: xAxisIndex,
            yAxisIndex: yAxisIndex,
            data: chartData,
          },
          opt || {},
          true
        );
      }

      // 		var myChartOne = Echarts.init(document.getElementById('NestingChart'));
      var option = {
        animation: false,
        //标题组件，包含主标题和副标题
        title: {
          x: "center",
          text: overviewTitle,
          //      subtext: overviewSubTitle,
          //      padding: 0,
        },
        tooltip: {
          //移动端展示方式
          trigger: "axis",
          transitionDuration: 0,
          confine: true,
          borderRadius: 4,
          borderWidth: 1,
          borderColor: "#333",
          backgroundColor: "rgba(255,255,255,0.9)",
          textStyle: {
            fontSize: 10,
            color: "#333",
          },
          formatter: function (params) {
            //数据单位格式化
            var relVal = params[0].name; //x轴名称
            relVal += "<div style='width:120px'>";
            for (var i = 0, l = params.length; i < l; i++) {
              if (params[i].value) {
                relVal +=
                  "<span  style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:" +
                  params[i].color +
                  ";'>" +
                  '<span  style="display:block;padding-left:15px;margin-top:-4px">' +
                  params[i].seriesName +
                  " : " +
                  params[i].value +
                  "</span>" +
                  "</span>" +
                  "<br>";
              }
            }
            relVal += "</div>";
            return relVal;
          },
        },

        //坐标轴指示器（axisPointer）的全局公用设置
        axisPointer: {
          type: "shadow",
          link: {
            xAxisIndex: "all",
          },
        },
        //直角坐标系内绘图网格
        grid: [
          // makeGrid(chartGridTop, chartGridHeight),
          // makeGrid(chartGridTop + (chartGridHeight + 10), chartGridHeight),
          // makeGrid(chartGridTop + (chartGridHeight + 10) * 2, chartGridHeight),
          // makeGrid(chartGridTop + (chartGridHeight + 10) * 3, chartGridHeight),
          // makeGrid(chartGridTop + (chartGridHeight + 10) * 4, chartGridHeight),
          // makeGrid(chartGridTop + (chartGridHeight + 10) * 5, chartGridHeight),
          // makeGrid(chartGridTop + (chartGridHeight + 10) * 6, chartGridHeight),
          // makeGrid(chartGridTop + (chartGridHeight + 10) * 7, chartGridHeight),
          makeGrid("2%", '9%'),
          makeGrid('14%', '9%'),
          makeGrid('26%', '9%'),
          makeGrid('38%', '9%'),
          makeGrid('50%', '9%'),
          makeGrid('62%', '9%'),
          makeGrid('73%', '9%'),
          makeGrid('85%', '9%'),
        ],
        xAxis: [
          makeXAxis(0),
          makeXAxis(1),
          makeXAxis(2),
          makeXAxis(3),
          makeXAxis(4),
          makeXAxis(5),
          makeXAxis(6),
          makeXAxis(7),
        ],
        yAxis: [
          makeYAxis(0, {
            name: "Hg",
            splitNumber: 2, //调整间隔
            splitLine: { show: false }, //去除网格线
          }),

          makeYAxis(1, {
            name: "As",
            splitNumber: 2,
            splitLine: { show: false }, //去除网格线
          }),
          makeYAxis(2, {
            name: "Cr",
            splitNumber: 2,
            splitLine: { show: false }, //去除网格线
          }),
          makeYAxis(3, {
            name: "Ni",
            splitNumber: 2,
            splitLine: { show: false }, //去除网格线
          }),
          makeYAxis(4, {
            name: "Zn",
            splitNumber: 2,
            splitLine: { show: false }, //去除网格线
          }),
          makeYAxis(5, {
            name: "Cu",
            splitNumber: 2,
            splitLine: { show: false }, //去除网格线
          }),
          makeYAxis(6, {
            name: "Pb",
            splitNumber: 2,
            splitLine: { show: false }, //去除网格线
          }),
          makeYAxis(7, {
            name: "Cd",
            splitNumber: 2,
            splitLine: { show: false }, //去除网格线
          }),
          // makeYAxis(0, {
          //   name: "热量对比",
          //   splitLine: false, //去除网格线
          //   splitNumber: 2,
          // }),
        ],
        //dataZoom 组件 用于区域缩放
        dataZoom: [
          {
            type: "slider",
            xAxisIndex: [0, 1, 2, 3, 4, 5, 6, 7],
            realtime: true,
            //移动端展示方式
            handleSize: "100%",
            start: 0,
            end: 30,
            height: 10,
            bottom: 8,
          },
        ],
        //每个系列通过 type 决定自己的图表类型
        series: [
          makeGridData(0, 0, "line", "Hg", Hg, {
            smooth: true,
            color: "#FF6A6A",
            lineStyle: {
              width: 1, //改变线条的粗细
            },
          }),

          makeGridData(1, 1, "line", "As", As, {
            stack: "DBTIME",
            smooth: true,
            color: "#FFC125",
            lineStyle: {
              width: 1, //改变线条的粗细
            },
          }),

          makeGridData(2, 2, "line", "Cr", Cr, {
            smooth: true,
            color: "#BA55D3",
            lineStyle: {
              width: 1, //改变线条的粗细
            },
          }),
          makeGridData(3, 3, "line", "Ni", Ni, {
            smooth: true,
            color: "#836FFF",
            lineStyle: {
              width: 1, //改变线条的粗细
            },
          }),
          makeGridData(4, 4, "line", "Zn", Zn, {
            smooth: true,
            color: "#4F94CD",
            lineStyle: {
              width: 1, //改变线条的粗细
            },
          }),
          makeGridData(5, 5, "line", "Cu", Cu, {
            smooth: true,
            color: "#4169E1",
            lineStyle: {
              width: 1, //改变线条的粗细
            },
          }),
          makeGridData(6, 6, "line", "Pb", Pb, {
            smooth: true,
            color: "#98F5FF",
            lineStyle: {
              width: 1, //改变线条的粗细
            },
          }),
          makeGridData(7, 7, "line", "Cd", Cd, {
            smooth: true,
            color: "#00FF7F",
            lineStyle: {
              width: 1, //改变线条的粗细
            },
          }),
        ],
      };
      charts1.setOption(option);
    },
    async initEcharts2() {
      const _this = this;
      const charts2 = Echarts.init(this.$refs["dhfj"]);

      var overviewChartID = "overview-chart";
      var overviewTitle = ""; //标题
      var overviewSubTitle = Echarts.format.formatTime(
        "yyyy年MM月dd",
        new Date()
      );

      //图表定位
      var chartGridTop = 10;
      var chartGridHeight = 130;

      //时间轴
      //SELECT WMSYS.WM_CONCAT('"'||TO_CHAR(TRUNC(SYSDATE, 'MM') + ROWNUM - 1, 'YYYY-MM-DD')||'"') DBTIME FROM DUAL CONNECT BY ROWNUM <= 30;
      var overviewDate = [
      
      ];

      //表格数据
      //SELECT WMSYS.WM_CONCAT(TRUNC(DBMS_RANDOM.VALUE(5, 60), 2)) DBTIME FROM DUAL CONNECT BY ROWNUM <= 30;

      var LMWPAHs = [
       
      ];
      var MMWPAHs = [
       
      ];
      var HMWPAHs = [
      
      ];
      var Σ16PAHs = [
        
      ];
      // 接口请求
      const params ={
        all:1
      }
      const res = await apiService.PAHsAverageAnnual(params)
      console.log(res.data.results)
      let list = res.data.results
      for(var i=0;i<list.length;i++){
        if(list[i].type=="LMW PAHs"){
          overviewDate.push(list[i].year)
          LMWPAHs.push(list[i].value)
        }  
        if(list[i].type=="MMW PAHs"){
          MMWPAHs.push(list[i].value)
        }  
        if(list[i].type=="HMW PAHs"){
          HMWPAHs.push(list[i].value)
        }  
        if(list[i].type=="Σ16PAHs"){
          Σ16PAHs.push(list[i].value)
        }  

      }
      //直角坐标系内绘图网格
      function makeGrid(top, height, opt) {
        return Echarts.util.merge(
          {
            left: 45,
            right: 8,
            top: top,
            height: height,
          },
          opt || {},
          true
        );
      }

      //X轴生成器
      function makeXAxis(gridIndex, opt) {
        //避免X轴数据显示过于频繁
        _this.axisLabelFlag = false;
        //  if (gridIndex % 2 == 0) {
        //      axisLabelFlag = true;
        //  }
        if (gridIndex == 3) {
          _this.axisLabelFlag = true;
        }

        return Echarts.util.merge(
          {
            type: "category",
            gridIndex: gridIndex,
            //统一时间轴数据
            data: overviewDate,
            axisLabel: {
              show: _this.axisLabelFlag,
              /*          formatter: function(value) {
					              return Echarts.format.formatTime('MM-dd', value);
					          }*/
            },
          },
          opt || {},
          true
        );
      }

      //Y轴生成器
      function makeYAxis(gridIndex, opt) {
        return Echarts.util.merge(
          {
            type: "value",
            // nameLocation: "middle",
            nameGap: "-5",
            gridIndex: gridIndex,
            nameTextStyle: {
              color: "#fff",
              padding: [100, 0, 0, 80],
            },
            axisTick: {
              show: true,
            },
            axisLabel: {
              show: true,
            },
          },
          opt || {},
          true
        );
      }

      //数据生成器
      function makeGridData(
        xAxisIndex,
        yAxisIndex,
        chartType,
        chartName,
        chartData,
        opt
      ) {
        return Echarts.util.merge(
          {
            type: chartType,
            name: chartName,
            xAxisIndex: xAxisIndex,
            yAxisIndex: yAxisIndex,
            data: chartData,
          },
          opt || {},
          true
        );
      }

      // 		var myChartOne = Echarts.init(document.getElementById('NestingChart'));
      var option = {
        animation: false,
        //标题组件，包含主标题和副标题
        title: {
          x: "center",
          text: overviewTitle,
          //      subtext: overviewSubTitle,
          //      padding: 0,
        },
        tooltip: {
          //移动端展示方式
          trigger: "axis",
          transitionDuration: 0,
          confine: true,
          borderRadius: 4,
          borderWidth: 1,
          borderColor: "#333",
          backgroundColor: "rgba(255,255,255,0.9)",
          textStyle: {
            fontSize: 10,
            color: "#333",
          },
          formatter: function (params) {
            //数据单位格式化
            var relVal = params[0].name; //x轴名称
            relVal += "<div style='width:120px'>";
            for (var i = 0, l = params.length; i < l; i++) {
              if (params[i].value) {
                relVal +=
                  "<span  style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:" +
                  params[i].color +
                  ";'>" +
                  '<span  style="display:block;padding-left:15px;margin-top:-4px">' +
                  params[i].seriesName +
                  " : " +
                  params[i].value +
                  "</span>" +
                  "</span>" +
                  "<br>";
              }
            }
            relVal += "</div>";
            return relVal;
          },
        },

        //坐标轴指示器（axisPointer）的全局公用设置
        axisPointer: {
          type: "shadow",
          link: {
            xAxisIndex: "all",
          },
        },
        //直角坐标系内绘图网格
        grid: [
          makeGrid('2%', '21%'),
          makeGrid('26%', '21%'),
          makeGrid('49%', '21%'),
          makeGrid('73%', '21%'),
          // makeGrid(chartGridTop, chartGridHeight),
          // makeGrid(chartGridTop + (chartGridHeight + 10), chartGridHeight),
          // makeGrid(chartGridTop + (chartGridHeight + 10) * 2, chartGridHeight),
          // makeGrid(chartGridTop + (chartGridHeight + 10) * 3, chartGridHeight),
        ],
        xAxis: [makeXAxis(0), makeXAxis(1), makeXAxis(2), makeXAxis(3)],
        yAxis: [
          makeYAxis(0, {
            name: "LMW PAHs",
            splitNumber: 2, //调整间隔
            splitLine: { show: false }, //去除网格线
          }),

          makeYAxis(1, {
            name: "MMW PAHs",
            splitNumber: 2,
            splitLine: { show: false }, //去除网格线
          }),
          makeYAxis(2, {
            name: "HMW PAHs",
            splitNumber: 2,
            splitLine: { show: false }, //去除网格线
          }),
          makeYAxis(3, {
            name: "Σ16PAHs",
            splitNumber: 2,
            splitLine: { show: false }, //去除网格线
          }),

          // makeYAxis(0, {
          //   name: "热量对比",
          //   splitLine: false, //去除网格线
          //   splitNumber: 2,
          // }),
        ],
        //dataZoom 组件 用于区域缩放
        dataZoom: [
          {
            type: "slider",
            xAxisIndex: [0, 1, 2, 3],
            realtime: true,
            //移动端展示方式
            handleSize: "100%",
            start: 0,
            end: 30,
            height: 10,
            bottom: 8,
          },
        ],
        //每个系列通过 type 决定自己的图表类型
        series: [
          makeGridData(0, 0, "line", "LMW PAHs", LMWPAHs, {
            smooth: true,
            color: "#FF6A6A",
            lineStyle: {
              width: 1, //改变线条的粗细
            },
          }),

          makeGridData(1, 1, "line", "MMW PAHs", MMWPAHs, {
            stack: "DBTIME",
            smooth: true,
            color: "#FFC125",
            lineStyle: {
              width: 1, //改变线条的粗细
            },
          }),

          makeGridData(2, 2, "line", "HMW PAHs", HMWPAHs, {
            smooth: true,
            color: "#BA55D3",
            lineStyle: {
              width: 1, //改变线条的粗细
            },
          }),
          makeGridData(3, 3, "line", "Σ16PAHs", Σ16PAHs, {
            smooth: true,
            color: "#836FFF",
            lineStyle: {
              width: 1, //改变线条的粗细
            },
          }),
        ],
      };
      charts2.setOption(option);
    },
    async initEcharts3() {
      const charts3 = Echarts.init(this.$refs["tdlyzb"]);
      const _this = this;
      // 接口请求
      const params ={
        all:1
      }
      const res = await apiService.LandUseRatio(params)
      console.log(res.data.results)
      let list = res.data.results
      let value1 = 0
      let value2 = 0
      let value3 = 0
      let value4 = 0
      let value5 = 0
      let value6 = 0
      let value7 = 0
      for(var i = 0;i<list.length;i++){
        if(list[i].type=="农田"){
          value1 = list[i].value
        }
        if(list[i].type=="森林"){
          value2 = list[i].value
        }
        if(list[i].type=="城镇"){
          value7 = list[i].value
        }
        if(list[i].type=="水域"){
          value5 = list[i].value
        }
        if(list[i].type=="草地"){
          value4 = list[i].value
        }
        if(list[i].type=="灌木"){
          value3 = list[i].value
        }
        if(list[i].type=="裸地"){
          value6 = list[i].value
        }
      }
      var m2R2Data = [
        {
          value: value1,

          legendname: "农田",
          name: "农田",
          itemStyle: {
            color: "#eac99c",
          },
        },
        {
          value: value2,

          legendname: "森林",
          name: "森林",
          itemStyle: {
            color: "#4a6f3a",
          },
        },
        {
          value: value3,

          legendname: "灌木",
          name: "灌木",
          itemStyle: {
            color: "#34a42c",
          },
        },
        {
          value:value4,

          legendname: "草地",
          name: "草地",
          itemStyle: {
            color: "#6c8644",
          },
        },
        {
          value: value5,

          legendname: "水体",
          name: "水体",
          itemStyle: {
            color: "#2e70b0",
          },
        },
        {
          value: value6,

          legendname: "裸土",
          name: "裸土",
          itemStyle: {
            color: "#acac6c",
          },
        },
        {
          value: value7,

          legendname: "城市",
          name: "城市",
          itemStyle: {
            color: "#d24f90",
          },
        },
      ];

      const option = {
        tooltip: {
          trigger: "item",
          // formatter: function (parms) {
          //   var str = parms.name + "<br/>" + "使用占比：" + parms.data.value+'(面积(平方千米))'+"<br/>"+"面积:"+parms.data.value+'(平方千米)';

          //   return str;
          // },
          formatter: "{a} <br/>{b} : {c} ({d}%)" + "(平方千米)",
        },
        legend: {
          type: "scroll",
          orient: "vertical",
          left: "55%",
          align: "left",
          top: "middle",
          itemWidth: 10,
          itemHeight: 8,
          textStyle: {
            color: "#fff",
            fontSize:14,
          },
        },
        series: [
          {
            name: "土地利用占比",
            type: "pie",
            center: ["35%", "50%"],
            radius: ["70%", "90%"],
            // clockwise: false, //饼图的扇区是否是顺时针排布
            avoidLabelOverlap: false,
            itemStyle: {
              //图形样式
              normal: {
                borderColor: "#ffffff",
                borderWidth: 1,
              },
            },
            label: {
              normal: {
                show: false,
                position: "outter",
                formatter: function (parms) {
                  return parms.data.legendname;
                },
              },
            },
            labelLine: {
              normal: {
                length: 10,
                length2: 8,
                smooth: true,
              },
            },
            data: m2R2Data,
          },
        ],
      };
      charts3.setOption(option);
    },
    async initEcharts4() {
      const charts4 = Echarts.init(this.$refs["zjssjl"]);
      const _this = this;
      
      let data = [];
      let className = [];
      // 接口请求
      const params ={
        all:1
      }
      const res = await apiService.MetalReference(params)
      console.log(res.data.results)
      let list = res.data.results
      for(var i=0;i<list.length;i++){
        data.push(list[i].reference_number)
        className.push(list[i].type)
      }
      const option = {
        backgroundColor: "#04112500",
        grid: {
          left: "5%",
          right: "8%",
          bottom: "2%",
          top: "3%",
          containLabel: true,
        },
        xAxis: {
          show: false,
          type: "value",
        },
        yAxis: [
          {
            type: "category",
            inverse: true,
            axisLabel: {
              show: true,
              textStyle: {
                color: "#D1E6EB",
                fontSize: 14,
              },
            },
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            data: className,
          },
        ],
        series: [
          {
            name: "员工出信息",
            type: "bar",
            zlevel: 1,
            label: {
              //数据显示的位置
              show: true, //数值是否显示
              // rotate: 60, //数值显示的角度
              position: "right", //数值相对于柱状图显示的位置
              textStyle: {
                color: "#FFFFFF", // 标签字体颜色
                fontSize: 12, // 标签字体大小
                fontStyle: "italic", // 标签字体斜体
                fontFamily: "baba", // 标签字体
              },
            },

            itemStyle: {
              normal: {
                barBorderRadius: 0,
                color: {
                  type: "linear",
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(94, 238, 255, 1)",
                    },
                    {
                      offset: 1,
                      color: "rgba(255, 255, 255, 0)",
                    },
                  ],
                },
              },
            },
            barWidth: 16,
            emphasis: {
              disabled: true,
              focus: "none",
            },
            data: data,
          },
          {
            // name: "外圆",
            type: "scatter",
            emphasis: {
              scale: false,
            },
            symbol: "rect",
            symbolSize: [4, 18], // 进度条白点
            itemStyle: {
              barBorderRadius: [30, 0, 0, 30],
              color: "#5EEEFF",
              shadowColor: "rgba(94, 238, 255, 0.5)",
              shadowBlur: 1,
              borderWidth: 1,
              opacity: 1,
            },
            z: 2,
            data: data,
            animationDelay: 500,
          },
        ],
      };
      charts4.setOption(option);
    },
    async initEcharts5() {
      const charts5 = Echarts.init(this.$refs["dhfjsjl"]);
      const _this = this;

      let data = [];
      let className = [
        
      ];
            // 接口请求
      const params ={
        all:1
      }
      const res = await apiService.PAHsReference(params)
      console.log(res.data.results)
      let list = res.data.results
      for(var i=0;i<list.length;i++){
        data.push(list[i].reference_number)
        className.push(list[i].type)
      }
      const option = {
        backgroundColor: "#04112500",
        grid: {
          left: "5%",
          right: "8%",
          bottom: "2%",
          top: "3%",
          containLabel: true,
        },
        xAxis: {
          show: false,
          type: "value",
        },
        yAxis: [
          {
            type: "category",
            inverse: true,
            axisLabel: {
              show: true,
              textStyle: {
                color: "#D1E6EB",
                fontSize: 14,
              },
            },
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            data: className,
          },
        ],
        series: [
          {
            name: "员工出信息",
            type: "bar",
            zlevel: 1,
            label: {
              //数据显示的位置
              show: true, //数值是否显示
              // rotate: 60, //数值显示的角度
              position: "right", //数值相对于柱状图显示的位置
              textStyle: {
                color: "#FFFFFF", // 标签字体颜色
                fontSize: 12, // 标签字体大小
                fontStyle: "italic", // 标签字体斜体
                fontFamily: "baba", // 标签字体
              },
            },

            itemStyle: {
              normal: {
                barBorderRadius: 0,
                color: {
                  type: "linear",
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(94, 238, 255, 1)",
                    },
                    {
                      offset: 1,
                      color: "rgba(255, 255, 255, 0)",
                    },
                  ],
                },
              },
            },
            barWidth: 13,
            emphasis: {
              disabled: true,
              focus: "none",
            },
            data: data,
          },
          {
            // name: "外圆",
            type: "scatter",
            emphasis: {
              scale: false,
            },
            symbol: "rect",
            symbolSize: [4, 18], // 进度条白点
            itemStyle: {
              barBorderRadius: [30, 0, 0, 30],
              color: "#5EEEFF",
              shadowColor: "rgba(94, 238, 255, 0.5)",
              shadowBlur: 1,
              borderWidth: 1,
              opacity: 1,
            },
            z: 2,
            data: data,
            animationDelay: 500,
          },
        ],
      };
      charts5.setOption(option);
    },
  },
  mounted() {
    // this.initEcharts();
    this.initEcharts1();
    this.initEcharts2();
    this.initEcharts3();
    this.initEcharts4();
    this.initEcharts5();
  },
};
</script>
<style lang="scss" scoped>
.qygk {
  height: 100%;
  display: flex;
  justify-content: space-around;
  .gk {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    // justify-content: center;
    position: relative;

    p {
      width: 90%;
      line-height: 24px;
      font-size: 16px;
      // height: 20%;
      overflow: hidden;
    }
    .ndtb {
      // border: 1px solid gray;
      flex: 1;
      width: 100%;
      padding: 10px 0;
      display: flex;
      .zjsnd {
        flex: 1;
        height: 100%;
      }
      .dhfj {
        flex: 1;
        height: 100%;
      }
    }
  }
  .mapBox {
    flex: 1;
    display: flex;
    align-items: center;
    position: relative;
    // .map{
    //     width: 100%;
    //     height: 80%;
    // }
  }
  .map {
    width: 450px;
    height: 480px;
  }
  .tdly {
    position: relative;
    box-sizing: border-box;
    // padding: 8px;
    display: flex;
    align-items: center;
    flex-direction: column;
    // justify-content: center;
    .imgbox {
      flex: 1;
      background-image: url(@/imgs/map.jpg);
      width: 100%;
      // height: 474px;
      // background-image: url(@/imgs/透明.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      // position: relative;
      // background-position: 54px;
      // .label {
      //   position: absolute;
      //   bottom: 0;
      //   div {
      //     display: flex;
      //     align-items: center;
      //     font-size: 14px;
      //     span {
      //       width: 20px;
      //       height: 10px;
      //       margin-right: 10px;
      //     }
      //   }
      // }
    }
    flex: 1;
  }
  .right {
    // padding: 8px;
    flex: 1;
    display: flex;
    flex-direction: column;
    .tdlyzb {
      height: 20%;
      width: 100%;
    }
    .sjltb {
      flex: 1;
      display: flex;
      .sjltb_item{
        flex: 1;
        display: flex;
        flex-direction: column;
        .zjssjl {
        flex: 1;
        height: 100%;
        width: 100%;
        }
        .dhfjsjl {
          flex: 1;
          height: 100%;
          width: 100%;
        }
      }

    }
  }
  .stitle {
    height: 40px;
    background-image: url(@/imgs/2-小标题.png);
    background-size: cover;
    line-height: 38px;
    padding-left: 20px;
    position: absolute;
    left: 10px;
    top: 10px;
    width: 200px;
  }
  .title {
    display: flex;
    align-items: center;
    width: 100%;
    font-size: 20px;
    padding: 4px;
    color: rgb(5, 225, 250);
    .yuan {
      width: 10px;
      height: 10px;
      border-radius: 5px;
      background-color: rgb(5, 225, 250);
      margin-right: 4px;
    }
  }
}
</style>